export default function() {}



//////////////////
// WEBPACK FOOTER
// ../~/d3-contour/src/noop.js
// module id = zOhu
// module chunks = 0